import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { login } from '../services/adminApi';

export default function Login() {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const success = await login(password);
      if (success) {
        navigate('/admin');
        window.location.reload();
      } else {
        setError('Falsches Passwort');
      }
    } catch (err) {
      setError('Login fehlgeschlagen');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="bg-black/40 backdrop-blur-xl border border-white/10 rounded-3xl p-8">
          <div className="text-center mb-8">
            <h1 className="text-2xl font-bold bg-gradient-to-r from-blue-400 to-purple-500 bg-clip-text text-transparent">
              MoodAPI Admin
            </h1>
            <p className="text-gray-500 text-sm mt-2">
              Bitte Passwort eingeben
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Admin Passwort"
                className="w-full px-4 py-3 bg-white/5 border border-white/10 rounded-xl text-white placeholder-gray-500 focus:outline-none focus:border-blue-500/50 transition-colors"
                autoFocus
              />
            </div>

            {error && (
              <div className="text-red-400 text-sm text-center bg-red-500/10 border border-red-500/20 rounded-xl py-2">
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={loading || !password}
              className={`
                w-full py-3 rounded-xl font-medium transition-all duration-200
                ${loading || !password
                  ? 'bg-gray-700 text-gray-400 cursor-not-allowed'
                  : 'bg-gradient-to-r from-blue-500 to-purple-600 text-white hover:opacity-90'
                }
              `}
            >
              {loading ? 'Wird geladen...' : 'Login'}
            </button>
          </form>
        </div>

        <p className="text-center text-gray-600 text-xs mt-4">
          MoodAPI Dashboard v1.0
        </p>
      </div>
    </div>
  );
}
